/* eslint-disable camelcase */
import React, { useState, useRef, useEffect, useCallback } from 'react';
import KickImage from 'Reuseables/KickImage';
import { connect } from 'react-redux';
import lod from 'lodash';
import { IconContext } from 'react-icons';
import { FaArrowLeft } from 'react-icons/fa';
import { GrFormDown } from 'react-icons/gr';
import { DropzoneRootProps, useDropzone } from 'react-dropzone';
import { toast } from 'react-toastify';

import { useOutsideAlerter } from '../../helpers/dom';

// ========= action import section ========= //
import { doSaveSkuRequest } from '../../actions/skuRequestAction';
import { getAllBrands } from '../../actions/filterAction';
// ====== end of action import section ====== //

// ========= interface import section ========= //
import RouteHistoryInterface from '../../interface/router';
import AuthInterface from '../../interface/reducers/auth';
// ====== end of interface import section ====== //

import IMAGE_UPLOAD from '../../images/upload.png';
import { getFileExt, ImagesCompressor } from '../../utils';
import { printError } from '../../utils/Helpers';
import { SUPPORTED_IMG_FORMATS } from '../../config';
import ModalOtherBrandInput from './components/ModalOtherBrand';
import DELETE_ICON from '../../images/delete1024.png';

type GetBrandType = {
  params: {
    category: string;
    keyword?: string;
  };
};

type SubmitSKUType = {
  category_name: string;
  brand_id?: number | null;
  display_name: string;
  other_brand?: string | null;
  SKU: string;
  img: File;
};

type skuRequest = {
  history: RouteHistoryInterface;
  dataAuth: AuthInterface;
  dataSkuRequest: any;
  // dispatch to props
  doFetchAllBrands: (query: GetBrandType) => Promise<any>;
  submitSkuRequest: (payloads: SubmitSKUType, id?: number) => Promise<any>;
};

type stateToProps = {
  dataAuth: AuthInterface;
};

const CATEGORY = [
  { label: 'Sneakers', value: 'sneakers' },
  { label: 'Apparel', value: 'apparels' },
  { label: 'Luxury', value: 'handbags' },
  { label: 'Electronics & Collectibles', value: 'lifestyles' },
];

/**
 * SKU Request User Dashboard section for Kick Avenue 3.0 Website.
 * Author: Rifqy Zacky Ariadhy (rifqyzackya@gmail.com)
 * ===============================================
 * @param {skuRequest} props for this component.
 * @return {JSX.Element}
 */
function SKURequest({
  history,
  doFetchAllBrands,
  submitSkuRequest,
  dataAuth,
  dataSkuRequest,
}: skuRequest): JSX.Element {
  const [afterRender, setAfterRender] = useState(false);
  useEffect(() => {
    setAfterRender(true);
    if (!dataAuth.isLogged) {
      history.push('/login');
    }
  }, []);

  const wrapperRefCategory = useRef(null);
  const [categoryOpened, setCategoryOpened] = useState(false);
  useOutsideAlerter(wrapperRefCategory, () => setCategoryOpened(false));

  const wrapperRefBrand = useRef(null);
  const [brandOpened, setBrandOpened] = useState(false);
  useOutsideAlerter(wrapperRefBrand, () => setBrandOpened(false));
  const [brandList, setBrandList] = useState<any[]>([]);
  const [brandCustomOpened, setBrandCustomOpened] = useState(false);
  const toggleCustomBrand = () => setBrandCustomOpened(!brandCustomOpened);

  const [selectedCategory, setSelectedCategory] = useState('');
  const [displayName, setDisplayName] = useState('');
  const [skuName, setSkuName] = useState('');
  const [selectedBrand, setSelectedBrand] = useState('');
  const [otherBrand, setOtherBrand] = useState('');
  const [brand, setBrand] = useState<any>(null);
  const [searchBrand, setSearchBrand] = useState('');
  const [errors, setErrors] = useState(null);

  const handleChangeSearchBrand = (e) => setSearchBrand(e.target.value);

  const isFullFiled = () => {
    if (!selectedCategory || selectedCategory === '') return false;
    if (!displayName || displayName === '') return false;
    if (!skuName || skuName === '') return false;
    if (!selectedBrand || selectedBrand === '') return false;

    return true;
  };

  const handleChangeDisplay = (e: any) => setDisplayName(e.target.value);
  const handleChangeSku = (e: any) => setSkuName(e.target.value);
  useEffect(() => {
    const query = { params: { category: selectedCategory } };
    doFetchAllBrands(query).then((res) => {
      setBrandList(res);
    });
    setBrand(null);
    setSearchBrand('');
    setSelectedBrand('');
    setOtherBrand('');
  }, [selectedCategory]);
  const handleSubmitOtherBrand = (val: string) => {
    const brands = brandList.filter((t) => t.id !== '' && !t.isCreated);
    let selected = { id: '', name: 'Brands*', isCreated: false };
    const arr = [selected];
    if (val !== '') {
      selected = {
        id: val,
        name: 'Other Brand: ' + val,
        isCreated: true,
      };
      arr.push(selected);
    }
    setBrand(selected);
    setBrandList([...arr, ...brands]);
    setBrandCustomOpened(false);
    setOtherBrand(val);
    setSearchBrand('Other Brand: ' + val);
  };
  useEffect(() => {
    if (!brand && afterRender) setKeywordThenSearch(searchBrand);
  }, [searchBrand]);
  const setKeywordThenSearch = useCallback(
    lod.debounce((t) => {
      const query = {
        params: { category: selectedCategory, name: t },
      };
      doFetchAllBrands(query).then((res) => {
        setBrandList(res);
        setBrandOpened(true);
      });
    }, 1000),
    [selectedCategory],
  );

  const [selectedPhoto, setSelectedPhoto] = useState<File | null>(null);
  const [selectedPhotoPreview, setSelectedPhotoPreview] =
    useState<{
      preview: string;
    }>(null);

  const { getRootProps, getInputProps } = useDropzone({
    accept: 'image/*',
    onDrop: (acceptedFiles: File[]) => {
      setSelectedPhoto(acceptedFiles[0]);
      setSelectedPhotoPreview({
        preview: URL.createObjectURL(acceptedFiles[0]),
      });
    },
  });
  let componentProps: DropzoneRootProps = !selectedPhoto ? getRootProps() : {};

  const onDeleteImage = () => {
    setSelectedPhoto(null);
  };

  const renderPhoto = () => {
    if (!selectedPhoto) {
      return (
        <div className={'photo-input'}>
          <KickImage className={'empty'} src={IMAGE_UPLOAD} />
          <p>
            Drag and drop your image here or{' '}
            <span className={'bold'}>browse</span>
          </p>
        </div>
      );
    } else {
      return (
        <div className={'photo-input'}>
          <div className="selected-photo">
            <KickImage
              src={selectedPhotoPreview?.preview}
              className={'image-photo'}
            />
            <div className="delete-image-icon" onClick={onDeleteImage}>
              <KickImage src={DELETE_ICON} alt="..." />
            </div>
          </div>
        </div>
      );
    }
  };

  const validateFilesExtension = (files: File) => {
    let isValid = true;
    const ext = getFileExt(files.name ? files.name : files.path);
    const isSupported =
      SUPPORTED_IMG_FORMATS.find(
        (i) => i === (ext ? ext.toLowerCase() : ext),
      ) !== undefined;
    if (!isSupported) {
      isValid = !isValid;
    }
    return isValid;
  };

  const getUnsupportedImageError = () =>
    `Uploaded file is not a valid image. Only ${SUPPORTED_IMG_FORMATS.join(
      ', ',
    )} files are allowed.`;

  const validatePicture = (err = {}) => {
    if (!validateFilesExtension(selectedPhoto))
      err['fileUploads'] = [getUnsupportedImageError()];
    return { ...err };
  };

  const validateForm = async () => {
    let error = {};
    if (
      selectedCategory === null ||
      (selectedCategory && selectedCategory.value === '')
    ) {
      error.category = ['Please select a category.'];
    }
    if (selectedBrand === null || (selectedBrand && selectedBrand.id === '')) {
      error.brand = ['Please select a brand.'];
    }
    if (displayName === '') {
      error.displayName = ['The display name field is required.'];
    }
    error = validatePicture(error);
    setErrors(
      Object.keys(error).length > 0
        ? {
            ...error,
          }
        : null,
    );
  };

  const compressImages = async () => {
    let compressor;
    try {
      compressor = await ImagesCompressor(selectedPhoto);
    } catch (e) {
      compressor = selectedPhoto;
    }

    return compressor;
  };

  const onSubmit = async () => {
    if (!isFullFiled()) return;

    await validateForm();
    if (!errors) {
      const compressed = await compressImages();
      setSelectedPhoto(compressed);

      const payloads = {
        category_name: selectedCategory,
        // brand_id: this.state.brand.isCreated === true ? null : this.state.brand.id,
        display_name: displayName,
        // other_brand: this.state.brand.isCreated === true ? this.state.brand.id : null,
        SKU: skuName === '' ? null : skuName,
        img: compressed,
      };

      if (otherBrand) {
        payloads.other_brand = brand.name;
      } else {
        payloads.brand_id = brand.id;
      }
      submitSkuRequest(payloads).then(() => {
        history.goBack();
      });
    }
  };

  const hasError = (name: string) => {
    if (errors !== null) {
      return Object.keys(errors).filter((err) => err === name).length > 0;
    }
    return false;
  };

  useEffect(() => {
    const { error } = dataSkuRequest;
    if (error) {
      const errorText = printError(error);
      toast.error(errorText, {
        position: 'top-right',
        autoClose: 5000,
        closeOnClick: true,
        pauseOnHover: true,
      });
    }
  }, [dataSkuRequest.error]);

  return (
    <div className={'page-container'} id={'sku-request-container'}>
      <div className={'container'}>
        <IconContext.Provider value={{ color: '#242424', size: '12.5px' }}>
          <div className={'back-button'} onClick={() => history.goBack()}>
            <FaArrowLeft />
          </div>
        </IconContext.Provider>
        <div className={'title-text'}>SKU Request</div>
        <div className={'input-section'}>
          <p>Category</p>
          <div className={'text-box'} onClick={() => setCategoryOpened(true)}>
            <p className={selectedCategory === '' ? 'placeholder' : ''}>
              {selectedCategory === ''
                ? 'Select Category'
                : CATEGORY.find((t) => t.value === selectedCategory).label}
            </p>
            <IconContext.Provider value={{ color: '#242424', size: '15px' }}>
              <div className={'icon-dropdown'}>
                <GrFormDown />
              </div>
            </IconContext.Provider>
          </div>
          {categoryOpened && (
            <div
              ref={wrapperRefCategory}
              className={'search-product-result-container'}
            >
              {CATEGORY.map((t) => {
                const onClick = () => {
                  setSelectedCategory(t.value);
                  setCategoryOpened(false);
                };
                return (
                  <div
                    className={`search-size-item${
                      t.value === selectedCategory ? ' selected' : ''
                    }`}
                    onClick={onClick}
                    key={t.value}
                  >
                    <p>{t.label}</p>
                  </div>
                );
              })}
            </div>
          )}
          {hasError('category') && (
            <p className={'error-text'}>{errors?.category}</p>
          )}
        </div>
        <div className={'input-section'}>
          <p>Display Name</p>
          <input
            type={'text'}
            placeholder={'Input Display Name'}
            onChange={handleChangeDisplay}
            value={displayName}
          />
          {hasError('displayName') && (
            <p className={'error-text'}>{errors?.displayName}</p>
          )}
        </div>
        <div className={'input-section'}>
          <p>SKU Number / Style Number</p>
          <input
            type={'text'}
            placeholder={'Input SKU Name'}
            onChange={handleChangeSku}
            value={skuName}
          />
        </div>
        <div className={'input-section'}>
          <p>Brand</p>
          <input
            type={'text'}
            placeholder={'Select Brand'}
            onChange={handleChangeSearchBrand}
            value={searchBrand}
            onFocus={() => setBrandOpened(true)}
          />
          {brandOpened && (
            <div
              ref={wrapperRefBrand}
              className={'search-product-result-container'}
            >
              {brandList.map((t) => {
                const onClick = () => {
                  setSelectedBrand(t.id);
                  setBrand(t);
                  setSearchBrand(t.name);
                  setBrandOpened(false);
                };
                return (
                  <div
                    className={`search-size-item${
                      t.id === selectedBrand ? ' selected' : ''
                    }`}
                    onClick={onClick}
                    key={t.id}
                  >
                    <p>{t.name}</p>
                  </div>
                );
              })}
              <div
                className={`search-size-item footer`}
                onClick={toggleCustomBrand}
              >
                <p>Can't find the brand?</p>
              </div>
            </div>
          )}
          {hasError('brand') && <p className={'error-text'}>{errors?.brand}</p>}
        </div>
        <div className={'photo-section'}>
          <p>Upload Product Label</p>
          <div {...componentProps}>
            <input {...getInputProps()} />
            {renderPhoto()}
          </div>
          {hasError('fileUploads') && (
            <p className={'error-text'}>{errors?.fileUploads}</p>
          )}
        </div>
        <div className={'submit-section'}>
          <div
            className={`submit-button${!isFullFiled() ? ' disabled' : ''}`}
            onClick={onSubmit}
          >
            <p>Submit</p>
          </div>
        </div>
      </div>
      <ModalOtherBrandInput
        isOpen={brandCustomOpened}
        toggle={toggleCustomBrand}
        value={otherBrand}
        onSubmit={handleSubmitOtherBrand}
      />
    </div>
  );
}

const mapStateToProps = (state: stateToProps) => {
  return {
    dataAuth: state.dataAuth,
    dataSkuRequest: state.dataSkuRequest.details,
  };
};

const mapDispatchToProps = (dispatch: (arg0: any) => any) => {
  return {
    doFetchAllBrands: (query: GetBrandType) => dispatch(getAllBrands(query)),
    submitSkuRequest: (payloads: SubmitSKUType, id?: number) =>
      dispatch(doSaveSkuRequest(payloads, id)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SKURequest);
